enum PROCHAINE_DATE_ENUM {
  DATE_PASSEE = "Date passée",
  INFERIEUR_1_MOIS = "< 1 mois",
  INFERIEUR_2_MOIS = "< 2 mois",
  INFERIEUR_6_MOIS = "< 6 mois",
  INFERIEUR_12_MOIS = "< 12 mois",
  INFERIEUR_24_MOIS = "< 24 mois",
  INFERIEUR_36_MOIS = "< 36 mois",
}

export default PROCHAINE_DATE_ENUM;

export enum INTERVALLE_DATE_PROCHE_ENUM {
  INFERIEUR_1_JOUR = "< 1 jour",
  INFERIEUR_1_SEMAINE = "< 1 semaine",
  INFERIEUR_1_MOIS = "< 1 mois",
  INFERIEUR_3_MOIS = "< 3 mois",
  INFERIEUR_6_MOIS = "< 6 mois",
}
